(function () {
  if (customElements.get('size-chart-modal')) return;

  class SizeChartModal extends HTMLElement {
    constructor() {
      super();
      this._onKeyDown = this._onKeyDown.bind(this);
      this._onDocumentClick = this._onDocumentClick.bind(this);
      this._previousFocus = null;
      this._movedToBody = false;
    }

    connectedCallback() {
      // Escape transformed/sticky ancestors so position:fixed centers on the viewport.
      if (!this._movedToBody && this.parentElement !== document.body) {
        document.body.appendChild(this);
        this._movedToBody = true;
        return;
      }

      this.dialog = this.querySelector('[data-size-chart-dialog]');
      this.querySelectorAll('[data-size-chart-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });
      document.addEventListener('click', this._onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('keydown', this._onKeyDown);
    }

    _onDocumentClick(event) {
      const opener = event.target.closest('[data-size-chart-open]');
      if (!opener) return;
      const targetId = opener.getAttribute('aria-controls');
      if (targetId && this.id === targetId) {
        event.preventDefault();
        this.open(opener);
      }
    }

    open(opener) {
      this._previousFocus = opener || document.activeElement;
      this.hidden = false;
      document.body.classList.add('size-chart-modal-open');
      document.addEventListener('keydown', this._onKeyDown);
      const closeBtn = this.querySelector('.size-chart-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      if (this.hidden) return;
      this.hidden = true;
      document.body.classList.remove('size-chart-modal-open');
      document.removeEventListener('keydown', this._onKeyDown);
      if (this._previousFocus && typeof this._previousFocus.focus === 'function') {
        this._previousFocus.focus();
      }
      this._previousFocus = null;
    }

    _onKeyDown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab' || this.hidden) return;
      const focusable = this._getFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    _getFocusable() {
      return Array.from(
        this.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetParent !== null);
    }
  }

  customElements.define('size-chart-modal', SizeChartModal);
})();
